var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgFullScreenIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5 3h3l2 1-2 1H5v3l-1 2-1-2V3h2zm14 0h-3l-2 1 2 1h3v3l1 2 1-2V3h-2zM3 16v5h5l2-1-2-1H5v-3l-1-2-1 2zm18 3v-3l-1-2-1 2v3h-3l-2 1 2 1h5v-2z",
    fill: "#9A9CAC"
  })));
}

export default SvgFullScreenIcon;